import React from 'react';

export const pastEmploymentHistory = (
  <div>
    <p>
      For the second step of your Individual Unemployability claim, we need to
      verify your past employment.
    </p>
    <p>
      To help speed up this process, you can send a Request for Employment
      Information (VA Form 21-4192) to each of your employers from the last 12
      months you worked. You’ll need to fill out some of the form with your
      details before sending it to your employer.
    </p>
    <p>
      VA will send the form on your behalf, but you may be able to get it
      completed more quickly.
    </p>
  </div>
);
